export default "<!-- Main content -->\n<section class=\"content\">\n\nYou do not have permission to access this page.\n\n</section><!-- /.content -->";